import api from './Api';

const BASE_URL = 'sites/';

export default {
  getAll: () => {
    return api.get(BASE_URL, {
      params: {
        advertiserLookup: true
      }
    });
  }, 
  getUserApproved: () => {
    return api.get(`${BASE_URL}user-approved`);
  },
  getByUserId: (userId) => {
    return api.get(`${BASE_URL}users`, {
      params: {
        id: userId,
        getLinks: true
      }
    });
  },
  getUserApprovedSitesForAdvertisers: () => {
    return api.get(`${BASE_URL}user-sites-for-advertiser-marketplace`, {
      params: {
        approved: true,
        advertiserLookup: true
      }
    });
  },
  addSiteByAdmin: (body) => {
    return api.post(`${BASE_URL}admin-add`, body);
  },
  add: (body) => {
    return api.post(BASE_URL, body);
  },
  add: (body) => {
    return api.post(BASE_URL, body);
  },
  patch: (body) => {
    return api.patch(`${BASE_URL}${body.id}`, body);
  },
  updateStatus: (id, status) => {
    return api.put(`${BASE_URL}${id}/status`, { status });
  },
  getTotalSitescount: (userId) => {
    return api.get(`${BASE_URL}users/${userId}/total-sites-count`);
  },
  getUserSitesWithLinks: () => {
    return api.get(`${BASE_URL}user-sites-with-links`);
  }
};
